// client/plugins/spacingAutocompletion.ts
import { Plugin } from "prosemirror-state";
import { HTMLBaseSpacing } from "../../db/HTMLBaseSpacing.js";
import { SPACING_KEY } from "../../schema/nodes/spacing.js";
var spacingAutocompletion = new Plugin({
  state: {
    init() {
      return {
        lastReplacement: null
      };
    },
    apply(tr, value) {
      return {
        lastReplacement: tr.getMeta("spacingCompletion") || (tr.docChanged ? null : value.lastReplacement)
      };
    }
  },
  props: {
    handleKeyDown(view, event) {
      const pluginState = this.getState(view.state);
      if (!pluginState)
        throw new Error("Plugin state not found");
      if (event.key === "Backspace" && pluginState.lastReplacement) {
        const { pos, original } = pluginState.lastReplacement;
        const currentPos = view.state.selection.$head.pos;
        if (currentPos === pos + 2) {
          const tr = view.state.tr.delete(pos, currentPos).insertText(original).setMeta("spacingCompletion", null);
          view.dispatch(tr);
          return true;
        }
        return false;
      }
      if (event.key !== " " && event.key !== "Enter")
        return false;
      const { $head } = view.state.selection;
      const end = $head.pos;
      const start = end - 3;
      const lastThreeChars = start >= 0 ? view.state.doc.textBetween(start, end) : "";
      if (lastThreeChars === "---") {
        const nodeType = view.state.schema.nodes[SPACING_KEY];
        if (!nodeType)
          throw new Error("node type " + SPACING_KEY + " not found.");
        const tr = view.state.tr.delete(start, end).insert(
          $head.before(),
          nodeType.create({
            data: JSON.stringify(new HTMLBaseSpacing({ hasDividingLine: true, dividingLineSize: "1px" }).toObject())
          })
        );
        view.dispatch(tr);
        return true;
      }
      return false;
    }
  }
});
export {
  spacingAutocompletion
};
